import React from 'react'

import Formik from './Formik'
import Modal from './Modal'

class ContactForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = { modal: false }
  }

  toggleModal = () => {
    this.setState({ modal: !this.state.modal })
  }

  render() {
    const { modal } = this.state
    return (
      <React.Fragment>
        {modal && <Modal close={this.toggleModal} />}
        <Formik displayModal={this.toggleModal} />
      </React.Fragment>
    )
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js